<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="昵称：" prop="nickname">
                <el-input v-model="model.nickname"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'memberEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                nickname: '',
                realname: '',
                sex: '',
                birthday: '',
                mobile: '',
                openid: '',
                openid_mini: '',
                unionid: '',
                face: '',
                regtime: '',
                lastlogin: '',
                state: '',
                credit: '',
                township_id: '',
                wechatid: '',
                is_sub: '',
                ditui: '',
            },
            getObj:{
                url:'/api/admin/member/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/member/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>